export type HourMode = '12h' | '24h';

/**
 * Resolves whether a locale displays time in 12h (am/pm) or 24h format
 */
export const getLocaleHourMode = (locale?: string): HourMode => {
  if (locale?.toLowerCase() === 'en-gb') return '12h';

  try {
    const { hourCycle, hour12 } = new Intl.DateTimeFormat(locale, {
      hour: 'numeric',
      minute: '2-digit',
    }).resolvedOptions();

    if (hourCycle === 'h11' || hourCycle === 'h12' || hour12 === true) return '12h';
    if (hourCycle === 'h23' || hourCycle === 'h24' || hour12 === false) return '24h';

    const sample = new Intl.DateTimeFormat(locale, { hour: 'numeric' }).format(
      new Date(2000, 0, 1, 13),
    );
    return sample.includes('13') ? '24h' : '12h';
  } catch {
    return '24h';
  }
};
